module.exports = "/images/demo_duration.png?c5bf4020522263028db3cf968e03f072";